import { TFunction } from 'i18next';
import { FieldItem, Values } from '@lib/interfaces/form';
import {
  getWidgetKindSelectorField,
  getPreviewButtonField,
  getAnnouncementFields,
  getExternalLinkFields,
  getWidgetDetailsFields,
  getVisibilityFields,
  CREATABLE_WIDGET_KINDS,
  getWidgetKindOptions,
} from 'routes/Home/utils/getWidgetTemplateSharedFields';

// Re-export for backward compatibility
export { CREATABLE_WIDGET_KINDS, getWidgetKindOptions };

interface GetFormFieldsArgs {
  t: TFunction<'translation', undefined>;
  onPreviewClick?: () => void;
  onFieldChange?: (values: Values) => void;
}

/**
 * Main function that returns form fields for widget template creation
 * Uses shared field definitions for consistency with edit form
 */
export default function getWidgetTemplateCreateFormFields({
  t,
  onPreviewClick,
  onFieldChange,
}: GetFormFieldsArgs): FieldItem[] {
  const config = { useDynamicVisibility: true };
  const kindConfig = { onPreviewClick, onFieldChange };
  const fields: FieldItem[] = [];

  // Widget kind selector (first field, only for create form)
  fields.push(getWidgetKindSelectorField(t, kindConfig));

  // Preview button (shown after kind is selected)
  fields.push(getPreviewButtonField(t, kindConfig));

  // Announcement-specific fields
  fields.push(...getAnnouncementFields(t, config));

  // External link-specific fields
  fields.push(...getExternalLinkFields(t, config));

  // Widget details (title, subtitle, icon)
  fields.push(...getWidgetDetailsFields(t, config));

  // Visibility toggle
  fields.push(...getVisibilityFields(t, config));

  return fields;
}
